import styled from 'styled-components';
import { EmptyMessage } from '../VariationOptionForm/style';

export const List = styled.ul`
  padding: 0;
  margin: 0;
  max-height: 400px;
  overflow: auto;
  padding-right: 5px;
  position: relative;
  ${({ customListStyles }) => customListStyles}
`;

export const Header = styled.div`
  margin-bottom: 50px;
  ${({ customStyles }) => customStyles}
`;

export const StyledEmptyMessage = styled(EmptyMessage)`
  list-style: none;
`;



// WEBPACK FOOTER //
// ./src/components/GenericList/style.js